import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus, vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useTheme } from '../../contexts/ThemeContext';

interface SQLQueryDisplayProps {
  query: string;
}

const SQLQueryDisplay: React.FC<SQLQueryDisplayProps> = ({ query }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { isDarkMode } = useTheme();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(query);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="rounded-xl overflow-hidden mb-4 border border-neutral-dark dark:border-dark-border">
      <div className="flex justify-between items-center bg-neutral-dark dark:bg-dark-secondary px-4 py-2">
        <h3 className="text-sm font-medium text-black dark:text-dark-textPrimary">SQL Query</h3>
        <button 
          onClick={copyToClipboard}
          className="text-xs bg-neutral hover:bg-neutral-light dark:bg-dark-accent dark:hover:bg-dark-border px-2 py-1 rounded text-text-secondary dark:text-dark-textSecondary"
        >
          {isCopied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <div className="overflow-hidden">
        <SyntaxHighlighter 
          language="sql" 
          style={isDarkMode ? vscDarkPlus : vs}
          customStyle={{ 
            margin: 0,
            maxHeight: '400px',
            padding: '1rem'
          }}
          wrapLongLines={true}
        >
          {query}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default SQLQueryDisplay;
